const initialState: sage.state.IJobs = {
    jobs: undefined,
    jobsLoadStatus: "none",
    jobLookup: {},
    jobLookupStatus: {},
    resultsLookup: {},
    resultsLookupStatus: {},
    taskStateCountsLookup: {},
    taskStateCountsLookupStatus: {},
    changeJobNameStatus: "none",
    jobsSpent: {},
    jobsSpentStatus: {},
    tasksEarned: {},
    tasksEarnedStatus: {},
    createJobStatus: "none",
    jobTasks: {},
    jobTasksStatus: {},
    jobTasksUpdatedAt: {},
    cancelJobStatus: "none",
};

export default function jobs(
    state: sage.state.IJobs = initialState,
    action: sage.actions.jobs.ReducerTypes
): sage.state.IJobs {
    switch (action.type) {
        case "com.sage.actions.jobs.ISetJobs":
            return {
                ...state,
                jobs: action.jobs,
                jobLookup: action.jobs.reduce(
                    (prev, curr) => ({ ...prev, [curr.id]: curr }),
                    state.jobLookup
                ),
            };
        case "com.sage.actions.jobs.ISetJobsLoadStatus":
            return {
                ...state,
                jobsLoadStatus: action.status,
            };
        case "com.sage.actions.jobs.ISetJob":
            return {
                ...state,
                jobs: !state.jobs
                    ? state.jobs
                    : state.jobs.map((j) =>
                          j.id === action.job.id ? action.job : j
                      ),
                jobLookup: {
                    ...state.jobLookup,
                    [action.job.id]: action.job,
                },
            };
        case "com.sage.actions.jobs.ISetJobLoadStatus":
            return {
                ...state,
                jobLookupStatus: {
                    ...state.jobLookupStatus,
                    [action.jobId]: action.status,
                },
            };
        case "com.sage.actions.jobs.ISetResults":
            return {
                ...state,
                resultsLookup: {
                    ...state.resultsLookup,
                    [action.jobId]: action.results,
                },
            };
        case "com.sage.actions.jobs.ISetFetchResultsStatus":
            return {
                ...state,
                resultsLookupStatus: {
                    ...state.resultsLookupStatus,
                    [action.jobId]: action.status,
                },
            };
        case "com.sage.actions.jobs.ISetJobsSpentAtPage":
            return {
                ...state,
                jobsSpent: {
                    ...state.jobsSpent,
                    [action.page]: action.jobs,
                },
            };
        case "com.sage.actions.jobs.ISetFetchJobsSpentStatus":
            return {
                ...state,
                jobsSpentStatus: {
                    ...state.jobsSpentStatus,
                    [action.page]: action.status,
                },
            };
        case "com.sage.actions.jobs.ISetFetchTasksSpentStatus":
            return {
                ...state,
                tasksEarnedStatus: {
                    ...state.tasksEarnedStatus,
                    [action.page]: action.status,
                },
            };
        case "com.sage.actions.jobs.ISetTasksEarnedAtPage":
            return {
                ...state,
                tasksEarned: {
                    ...state.tasksEarned,
                    [action.page]: action.tasks,
                },
            };
        case "com.sage.actions.jobs.ISetCreateJobStatus":
            return {
                ...state,
                createJobStatus: action.status,
            };
        case "com.sage.actions.jobs.ISetJobTasks":
            return {
                ...state,
                jobTasks: {
                    ...state.jobTasks,
                    [action.jobId]: action.tasks,
                },
            };
        case "com.sage.actions.jobs.ISetJobTasksStatus":
            return {
                ...state,
                jobTasksStatus: {
                    ...state.jobTasksStatus,
                    [action.jobId]: action.status,
                },
            };
        case "com.sage.actions.jobs.ISetJobTasksUpdate": {
            const taskMap = action.tasks.reduce<{
                [id: string]: sage.model.ITask;
            }>((prevValue, currValue) => {
                prevValue[currValue.id] = currValue;
                return prevValue;
            }, {});
            return {
                ...state,
                jobTasks: {
                    ...state.jobTasks,
                    [action.jobId]: (state.jobTasks[action.jobId] || []).map(
                        (t) => {
                            if (taskMap[t.id]) {
                                return taskMap[t.id];
                            } else {
                                return t;
                            }
                        }
                    ),
                },
            };
        }
        case "com.sage.actions.jobs.ISetJobTasksUpdatedAt":
            return {
                ...state,
                jobTasksUpdatedAt: {
                    ...state.jobTasksUpdatedAt,
                    [action.jobId]: action.updatedAt,
                },
            };
        case "com.sage.actions.jobs.ISetCancelJobStatus":
            return {
                ...state,
                cancelJobStatus: action.status,
            };
        default:
            return state;
    }
}
